import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { LangContext } from '../App';

const T = {
  fr: {
    title: 'Page introuvable',
    sousTitre: "La page que vous cherchez n'existe pas ou a été déplacée.",
    bouton: "← Retour à l'accueil",
  },
  en: {
    title: 'Page not found',
    sousTitre: 'The page you are looking for does not exist or has been moved.',
    bouton: '← Back to home',
  },
};

export default function NotFound() {
  const { lang } = useContext(LangContext);
  const t = T[lang];

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--couleur-fond)',
        color: 'var(--couleur-texte)',
      }}
    >
      <Header />

      <section style={{ padding: '6rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '5rem',
              color: 'var(--couleur-or)',
              opacity: 0.5,
              marginBottom: '0.5rem',
              lineHeight: 1,
            }}
          >
            404
          </div>

          <h1
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '2rem',
              color: 'var(--couleur-texte)',
              margin: '0 0 1rem',
            }}
          >
            {t.title}
          </h1>

          <p
            style={{
              color: 'rgba(255,255,255,0.55)',
              fontSize: '1rem',
              marginBottom: '2.5rem',
              lineHeight: 1.6,
            }}
          >
            {t.sousTitre}
          </p>

          <Link
            to="/"
            style={{
              display: 'inline-block',
              background: 'var(--couleur-or)',
              color: 'var(--couleur-fond-carte)',
              padding: '0.85rem 2.2rem',
              borderRadius: '6px',
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: '1rem',
              boxShadow: '0 4px 16px rgba(201,162,39,0.35)',
            }}
          >
            {t.bouton}
          </Link>
        </div>
      </section>
    </div>
  );
}
